// Shared date-range presets used by Transactions and Dashboard.
//
// IMPORTANT, Timezone correctness:
// We deliberately format dates in **local time** (YYYY-MM-DD) rather than via
// `Date.toISOString()`. `toISOString()` converts to UTC, which silently shifts
// boundaries for non-UTC timezones (e.g., IST = UTC+5:30), turning "May 1
// local" into "Apr 30 UTC" and pulling prior-month transactions into "This
// month" filters. The helpers below always return YYYY-MM-DD strings in the
// user's local calendar, then compare as strings against `transactions.txn_date`
// (a DATE column stored as YYYY-MM-DD).

export const RANGE_PRESETS = [
  { value: 'last_7',     label: 'Last 7 days' },
  { value: 'last_30',    label: 'Last 30 days' },
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'custom',     label: 'Custom' },
  { value: 'all',        label: 'All' },
];

// Local-time YYYY-MM-DD formatter. Do NOT use `.toISOString()` here, it
// converts to UTC and breaks date boundaries for non-UTC timezones.
export function isoLocal(date) {
  if (!date) return null;
  const d = (date instanceof Date) ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Resolve a preset (+ optional custom start/end YYYY-MM-DD) into a
// `{ from, to }` window inclusive on both ends. Returns nulls for 'all'.
export function resolveRange(preset, customStart, customEnd) {
  const today = new Date();
  const subDays = (n) => {
    const x = new Date(today);
    x.setDate(x.getDate() - n);
    return x;
  };
  switch (preset) {
    case 'last_7':     return { from: isoLocal(subDays(6)),  to: isoLocal(today) };
    case 'last_30':    return { from: isoLocal(subDays(29)), to: isoLocal(today) };
    case 'this_month': {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      return { from: isoLocal(start), to: isoLocal(today) };
    }
    case 'last_month': {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end   = new Date(today.getFullYear(), today.getMonth(), 0); // last day of previous month
      return { from: isoLocal(start), to: isoLocal(end) };
    }
    case 'custom':     return { from: customStart || null, to: customEnd || null };
    case 'all':
    default:           return { from: null, to: null };
  }
}

// Inclusive YYYY-MM-DD string compare. Empty bounds = unbounded.
export function txnInRange(txnDate, from, to) {
  const d = txnDate || '';
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
}
